import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClinicalDecisionSupport = ({ alerts, onAlertAction }) => {
  if (alerts?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-warning/10 rounded-lg">
          <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">Clinical Decision Support</h3>
          <p className="text-xs md:text-sm text-muted-foreground">{alerts?.length} active alert{alerts?.length !== 1 ? 's' : ''}</p>
        </div>
      </div>
      <div className="space-y-3">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            className={`p-4 rounded-lg border-2 ${
              alert?.severity === 'critical' ?'bg-destructive/5 border-destructive/20'
                : alert?.severity === 'warning' ?'bg-warning/5 border-warning/20' :'bg-primary/5 border-primary/20'
            }`}
          >
            <div className="flex items-start gap-3">
              <Icon
                name={alert?.severity === 'critical' ? 'AlertCircle' : alert?.severity === 'warning' ? 'AlertTriangle' : 'Info'}
                size={20}
                color={
                  alert?.severity === 'critical' ?'var(--color-destructive)'
                    : alert?.severity === 'warning' ?'var(--color-warning)' :'var(--color-primary)'
                }
                className="flex-shrink-0 mt-0.5"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <p className="text-sm font-semibold text-foreground">{alert?.title}</p>
                  <span
                    className={`text-xs px-2 py-1 rounded flex-shrink-0 ${
                      alert?.severity === 'critical' ?'bg-destructive/10 text-destructive'
                        : alert?.severity === 'warning' ?'bg-warning/10 text-warning' :'bg-primary/10 text-primary'
                    }`}
                  >
                    {alert?.severity}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-muted-foreground mb-3">{alert?.message}</p>
                {alert?.recommendation && (
                  <div className="p-3 bg-background rounded-lg mb-3">
                    <p className="text-xs font-medium text-foreground mb-1">Recommendation:</p>
                    <p className="text-xs text-muted-foreground">{alert?.recommendation}</p>
                  </div>
                )}
                <div className="flex flex-wrap gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onAlertAction(alert?.id, 'acknowledge')}
                  >
                    Acknowledge
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onAlertAction(alert?.id, 'view-details')}
                  >
                    View Details
                  </Button>
                  {alert?.actionable && (
                    <Button
                      variant="default"
                      size="sm"
                      onClick={() => onAlertAction(alert?.id, 'take-action')}
                    >
                      Take Action
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClinicalDecisionSupport;